import React from 'react';

import { EmptyState, Link, ScreenContainer } from "../../components/wombat-ui";
import useTranslations from "../../hooks/useTranslations";

import PrivacyPolicyFR from "../../pages/fr-FR/PrivacyPolicy";
import TermsOfSaleFR from "../../pages/fr-FR/TermsOfSale";
import TermsAndConditionsFR from "../../pages/fr-FR/TermsAndConditions";

// I have absolutely no doubt that there's a better way to do it
const PAGES = {
  'fr-FR': {
    PrivacyPolicy: PrivacyPolicyFR,
    TermsOfSale: TermsOfSaleFR,
    TermsAndConditions: TermsAndConditionsFR
  }
}

const LocalizedPages = ({
  locale = 'FR-fr',
  page,
  ...props
}) => {
  const t = useTranslations();

  if (!PAGES[locale]?.[page]) {
    return (
      <EmptyState
        id="pageNotFound"
        title={t("network.notFound") as string}
        action={
          <Link variant="button" to="/">
            {t("network.backToHome")}
          </Link>
        }
      />
    )
  }

  return (
    <ScreenContainer>
      <div id="localizedPage">
        {React.createElement(PAGES[locale][page], props)}
      </div>
    </ScreenContainer>
  );
}

export default LocalizedPages;
